// extracted by mini-css-extract-plugin
export default {"sub_header_info":"sub-header-info_sub_header_info__OFG1Q","icon_img":"sub-header-info_icon_img__5Vg1P","text_info":"sub-header-info_text_info__47w6R"};